module.exports = __webpack_public_path__ + "static/media/4.HatiAyam.05ee9c94.jpeg";